import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getResourceCatalog } from '../services'
import type { ResponseArray } from '@/types/shared'
import type { ResourceGroup } from '../types'

export const useResourceCatalog = () => {
    const query = useQueryWithHandler<ResponseArray<ResourceGroup>>(
        {
            queryKey: [QUERY_KEYS.DATA_ACCESS_ASSIGNMENTS, 'resource-catalog'],
            queryFn: getResourceCatalog as () => Promise<
                ResponseArray<ResourceGroup>
            >,
            staleTime: 60 * 60 * 1000, // 1 hour
        },
        { showLoading: false }
    )

    const groups: ResourceGroup[] = query.data?.results ?? []

    return { ...query, groups }
}
